(function(){
  /* INT 2026-09-09 PERF. This was a 32 KB inline <script> in
     snippets/searchanise-instant.liquid, rendered into EVERY page of the store
     (theme.liquid includes that snippet before </body>), so it was rebuilt by the
     server and re-parsed by the browser on every single view. It now lives here,
     fetched once and cached, in the same shape as assets/searchanise-navigation.js.
     The handful of values Liquid knows arrive through the #si-cfg JSON block the
     snippet still renders. SI.t holds the translation strings HTML escaped, exactly
     as the `escape` filter produced them, because they are concatenated into
     innerHTML. Missing config returns quietly rather than throwing. */
  const SI = (function () {
    try { return JSON.parse(document.getElementById('si-cfg').textContent); }
    catch (e) { return null; }
  })();
  if (!SI) return;
  'use strict';

  const API_KEY = SI.apiKey;
  const ENDPOINT = 'https://searchserverapi1.com/getresults';
  const API_PAGE = '/pages/page-searchanise-api';
  const MAX_PRODUCTS = 9;
  const MAX_SUGGESTIONS = 4;
  /* Ask the API for more than we display, so that entries removed by market
     suppression (see sections/int-market-hide.liquid) do not consume a visible
     slot. Always filter first, then slice to the *_SHOWN limit. */
  const MAX_CATEGORIES_FETCHED = 12;
  const MAX_CATEGORIES_SHOWN = 3;
  const MAX_PAGES_FETCHED = 12;
  const MAX_PAGES_SHOWN = 3;
  const DEBOUNCE_MS = 250;

  /* ── Elements ── */
  const panel    = document.getElementById('si_panel');
  const backdrop = document.getElementById('si_backdrop');
  const input    = document.getElementById('si_input');
  const closeBtn = document.getElementById('si_close');
  const body     = document.getElementById('si_body');
  const leftCol  = document.getElementById('si_left');
  const rightCol = document.getElementById('si_right');
  const loader   = document.getElementById('si_loader');

  if (!panel || !input) return;

  let isOpen = false;
  let debounceTimer = null;
  let activeRequestId = 0;
  let lastQuery = '';

  /* ── Currency helper ── */
  const CURRENCY = SI.currency;
  const LOCALE = document.documentElement.lang || 'da-DK';

  /* INT 2026-06: active-market currency + filter. Same rationale as the
     collection renderer: the API is market-agnostic, so hide products with no
     >0 price in the active currency (per-currency gift cards, market-excluded
     products). Currency-only match handles EUR representative-country keying. */
  const SI_MARKET_CUR = (window.Shopify && Shopify.currency && Shopify.currency.active) || CURRENCY;
  function siOfferedInMarket(item) {
    var sfx = '_' + SI_MARKET_CUR, vs = item && item.shopify_variants;
    if (!Array.isArray(vs) || !vs.length) return true;
    for (var i = 0; i < vs.length; i++) { var v = vs[i];
      for (var k of Object.keys(v)) { if (k.startsWith('price_') && k.endsWith(sfx)) { var p = parseFloat(v[k]); if (isFinite(p) && p > 0) return true; } }
    }
    return false;
  }

  function money(n) {
    n = Number(n);
    if (!isFinite(n)) return '';
    return n.toLocaleString(LOCALE, { style: 'currency', currency: CURRENCY, minimumFractionDigits: 2 });
  }

  function escapeHtml(s) {
    return String(s ?? '')
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* ── Highlight search term in text ── */
  function highlight(text, query) {
    if (!query || !text) return escapeHtml(text);
    const safe = escapeHtml(text);
    const qWords = query.trim().toLowerCase().split(/\s+/).filter(Boolean);
    var result = safe;
    qWords.forEach(function(w) {
      var re = new RegExp('(' + w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'gi');
      result = result.replace(re, '<mark>$1</mark>');
    });
    return result;
  }

  /* ── Product label detection ── */
  function getLabels(item) {
    var labels = [];
    var tags = [];
    if (Array.isArray(item.tags)) {
      tags = item.tags.map(function(t){ return String(t).toLowerCase().trim(); });
    } else if (typeof item.tags === 'string') {
      tags = item.tags.toLowerCase().split(',').map(function(t){ return t.trim(); });
    }

    if (tags.indexOf('organic') !== -1 || item.label_organic || item['label_Organic'])
      labels.push({ text: 'Organic', cls: 'si-label-organic' });
    if (tags.indexOf('recycled blend') !== -1 || tags.indexOf('recycled') !== -1 ||
        item.label_recycled_blend || item['label_Recycled Blend'])
      labels.push({ text: 'Recycled Blend', cls: 'si-label-recycled' });
    if (tags.indexOf('word of intention') !== -1 || tags.indexOf('intention') !== -1 ||
        item.label_word_of_intention || item['label_Word of Intention'])
      labels.push({ text: 'Word of Intention', cls: 'si-label-intention' });

    return labels;
  }

  /* ── Subtitle from metafield ── */
  function pickSubtitle(item) {
    var mf = item.metafield_c6c3e4a64c51d8e0740af1977e52de13;
    if (mf) return String(mf);
    if (item.product_type) return item.product_type;
    return '';
  }

  /* ── Image helpers (matching navigation snippet logic) ── */
  function pickMainImage(item) {
    if (item.image_link) return item.image_link;
    if (Array.isArray(item.shopify_images) && item.shopify_images.length) return item.shopify_images[0];
    return '';
  }

  function pickFlipImage(item) {
    if (item.image_link_2) return item.image_link_2;
    if (item.image_link2) return item.image_link2;
    if (item.image_link_secondary) return item.image_link_secondary;
    if (item.second_image_link) return item.second_image_link;
    if (item.image2) return item.image2;
    if (item.alt_image_link) return item.alt_image_link;
    if (item.additional_image_link) {
      return Array.isArray(item.additional_image_link) ? item.additional_image_link[0] : item.additional_image_link;
    }
    if (Array.isArray(item.shopify_images) && item.shopify_images.length > 1) return item.shopify_images[1];
    return '';
  }

  /* ── Price helpers ── */
  function pickPrice(item) {
    var priceSuffix = '_' + CURRENCY;
    if (Array.isArray(item.shopify_variants) && item.shopify_variants.length) {
      var v = item.shopify_variants[0];
      for (var k of Object.keys(v)) {
        if (k.startsWith('price_') && k.endsWith(priceSuffix)) {
          var p = parseFloat(v[k] || 0);
          if (isFinite(p) && p > 0) return p;
        }
      }
    }
    return parseFloat(item.price || 0);
  }

  function pickLowestPrice(item) {
    if (!Array.isArray(item.shopify_variants) || item.shopify_variants.length <= 1) return null;
    var priceSuffix = '_' + CURRENCY;
    var lowest = Infinity;
    item.shopify_variants.forEach(function(v) {
      var p = 0;
      for (var k of Object.keys(v)) {
        if (k.startsWith('price_') && k.endsWith(priceSuffix)) { p = parseFloat(v[k] || 0); break; }
      }
      if (!p) p = parseFloat(v.price || v.variant_price || 0);
      if (isFinite(p) && p > 0 && p < lowest) lowest = p;
    });
    return isFinite(lowest) && lowest < Infinity ? lowest : null;
  }

  /* ── Open / Close ── */
  function openSearch() {
    if (isOpen) return;
    isOpen = true;
    panel.classList.add('si-open');
    backdrop.classList.add('si-visible');
    document.body.style.overflow = 'hidden';
    setTimeout(function(){ input.focus(); }, 100);
    if (input.value.trim()) {
      doSearch(input.value.trim());
    }
  }

  function closeSearch() {
    if (!isOpen) return;
    isOpen = false;
    panel.classList.remove('si-open');
    panel.classList.remove('si-has-content');
    backdrop.classList.remove('si-visible');
    document.body.style.overflow = '';
  }

  /* ── API call via JSONP ── */
  function fetchResults(query) {
    var cb = '__siCb_' + Math.random().toString(36).slice(2);
    var qs = new URLSearchParams();
    qs.set('apiKey', API_KEY);
    qs.set('output', 'jsonp');
    qs.set('callback', cb);
    qs.set('q', query);
    qs.set('maxResults', String(MAX_PRODUCTS));
    qs.set('suggestions', 'true');
    qs.set('suggestionsMaxResults', String(MAX_SUGGESTIONS));
    qs.set('pages', 'true');
    qs.set('pagesMaxResults', String(MAX_PAGES_FETCHED));
    qs.set('categories', 'true');
    qs.set('categoriesMaxResults', String(MAX_CATEGORIES_FETCHED));
    qs.set('facets', 'false');
    var __siCur=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'';var __siCtry=(window.Shopify&&Shopify.country)||'';if(__siCur)qs.set('shopify_currency',__siCur);if(__siCtry)qs.set('shopify_country',__siCtry);
    /* INT 2026-09-12: restrict the search box to the active market's own catalogue. Without it
       the nine result slots fill with EU products that 404 for a US shopper. See
       snippets/searchanise-navigation.liquid for why the handle arrives through the config island. */
    if(SI.market&&!qs.has('restrictBy[tags]'))qs.set('restrictBy[tags]','market:'+SI.market);

    var url = ENDPOINT + '?' + qs.toString();
    activeRequestId++;
    var myId = activeRequestId;

    return new Promise(function(resolve, reject) {
      var s = document.createElement('script');
      var timeout = setTimeout(function(){ cleanup(); reject(new Error('timeout')); }, 12000);

      function cleanup() {
        clearTimeout(timeout);
        try { delete window[cb]; } catch(e) {}
        if (s.parentNode) s.parentNode.removeChild(s);
      }

      window[cb] = function(data) {
        if (myId !== activeRequestId) { cleanup(); return; }
        cleanup();
        resolve(data);
      };

      s.src = url;
      s.async = true;
      s.onerror = function(){ cleanup(); reject(new Error('network')); };
      document.head.appendChild(s);
    });
  }

  /* ── Market suppression (see sections/int-market-hide.liquid) ── */
  var __intHide=(function(){try{var el=document.getElementById('int-market-hide');if(!el)return{collections:[],pages:[],no_products:null};var o=JSON.parse(el.textContent||'{}');return{collections:Array.isArray(o.collections)?o.collections:[],pages:Array.isArray(o.pages)?o.pages:[],collection_titles:Array.isArray(o.collection_titles)?o.collection_titles:[],no_products:o.no_products||null};}catch(e){return{collections:[],pages:[],no_products:null};}})();
  function __intHandleFrom(s){if(!s)return '';var m=String(s).split('?')[0].split('#')[0].replace(/\/+$/,'').split('/');return m[m.length-1]||'';}
  function __intHidden(kind,item){var list=__intHide[kind];if(!list||!list.length)return false;var h=(item&&(item.handle||''))||'';if(!h)h=__intHandleFrom(item&&(item.link||item.url||''));return h?list.indexOf(h)!==-1:false;}

  /* INT 2026-08-27: market suppression for PRODUCTS.
     A price in the active currency is NOT catalogue membership - Searchanise
     indexes price_US_USD on apparel that is not published to the US market, so
     the currency guard passes it and the card 404s on click. A collection that
     is empty in a market cannot contain a product that is sold in that market,
     so a result belonging to one of this market's hidden collections is not
     buyable here. Searchanise gives each item its collection TITLES in
     `collections`, [:ATTR:]-joined; match those against the same list that
     already drives the Collections suggestion group. One list, both jobs. */
  function __intHandleizeTitle(t){return String(t||'').toLowerCase().replace(/['\u2019]/g,'').replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'');}
  var __intHiddenCollKeys=(function(){var s={},L=(__intHide.collections)||[],T=(__intHide.collection_titles)||[],i;
    for(i=0;i<L.length;i++){var a=__intHandleizeTitle(L[i]);if(a)s[a]=1;}
    for(i=0;i<T.length;i++){var b=__intHandleizeTitle(T[i]);if(b)s[b]=1;}return s;})();
  function __intMarketNote(){
    var c=(__intHide&&__intHide.no_products)||null;
    if(!c||(!c.title&&!c.line1))return '';
    var h='<div class="int-mkt-note">';
    if(c.title)h+='<div class="int-mkt-note__title">'+escapeHtml(c.title)+'</div>';
    if(c.line1)h+='<p class="int-mkt-note__line">'+escapeHtml(c.line1)+'</p>';
    if(c.line2)h+='<p class="int-mkt-note__line">'+escapeHtml(c.line2)+'</p>';
    var L=Array.isArray(c.links)?c.links:[];
    if(L.length){h+='<div class="int-mkt-note__links">';
      for(var i=0;i<L.length;i++){if(!L[i]||!L[i].label)continue;
        h+='<a class="int-mkt-note__cta" href="'+escapeHtml(L[i].url||'#')+'">'+escapeHtml(L[i].label)+'</a>';}
      h+='</div>';}
    if(c.soft&&c.soft.label)h+='<span class="int-mkt-note__soft"><a href="'+escapeHtml(c.soft.url||'#')+'">'+escapeHtml(c.soft.label)+'</a></span>';
    return h+'</div>';}
  function __intProductHidden(item){
    var raw=(item&&item.collections)||'';if(!raw)return false;
    var parts=String(raw).split('[:ATTR:]');
    for(var i=0;i<parts.length;i++){var h=__intHandleizeTitle(parts[i]);if(h&&__intHiddenCollKeys[h]===1)return true;}
    return false;}


  /* ── Render functions ── */

  function renderSuggestions(suggestions, query) {
    if (!Array.isArray(suggestions) || !suggestions.length) return '';
    var html = '<div class="si-suggestions">';
    html += '<div class="si-section-title">Suggestions</div>';
    suggestions.forEach(function(s) {
      var text = s.title || s.suggestion || s;
      if (typeof text !== 'string') text = String(text);
      var href = API_PAGE + '?q=' + encodeURIComponent(text);
      html += '<a class="si-suggestion-item" href="' + escapeHtml(href) + '">'
            + highlight(text, query) + '</a>';
    });
    html += '</div>';
    return html;
  }

  function renderCategories(categories, query) {
    if (!Array.isArray(categories) || !categories.length) return '';
    categories = categories.filter(function(c){ return !__intHidden('collections', c); });
    if (!categories.length) return '';
    if (categories.length > MAX_CATEGORIES_SHOWN) categories = categories.slice(0, MAX_CATEGORIES_SHOWN);
    var html = '<div class="si-categories">';
    html += '<div class="si-section-title">Collections</div>';
    categories.forEach(function(c) {
      var title = c.title || c.value || c.name || c.label || '';
      var link = c.link || c.url || ('/collections/' + (c.handle || encodeURIComponent(title.toLowerCase().replace(/\s+/g, '-'))));
      html += '<a class="si-cat-item" href="' + escapeHtml(link) + '">'
            + highlight(title, query) + '</a>';
    });
    html += '</div>';
    return html;
  }

  function renderPages(pages, query) {
    if (!Array.isArray(pages) || !pages.length) return '';
    pages = pages.filter(function(p){ return !__intHidden('pages', p); });
    if (!pages.length) return '';
    if (pages.length > MAX_PAGES_SHOWN) pages = pages.slice(0, MAX_PAGES_SHOWN);
    var html = '<div class="si-pages">';
    html += '<div class="si-section-title">Pages</div>';
    pages.forEach(function(p) {
      var title = p.title || p.value || p.name || '';
      var link = p.link || p.url || '';
      html += '<a class="si-page-item" href="' + escapeHtml(link) + '">'
            + highlight(title, query) + '</a>';
    });
    html += '</div>';
    return html;
  }

  /* INT badges — added 2026-06 */
  var INT_BADGE = {
    days: SI.badgeNewDays,
    wotm: SI.badgeWordOfMonth,
    urls: {
      "new":     "https://cdn.shopify.com/s/files/1/0924/7185/3320/files/badge-new-linen.svg?v=1787905391",
      "style":   "https://cdn.shopify.com/s/files/1/0924/7185/3320/files/badge-new-style-linen.svg?v=1787905391",
      "limited": "https://cdn.shopify.com/s/files/1/0924/7185/3320/files/badge-limited-edition-linen.svg?v=1787905391",
        "bpa":     "https://cdn.shopify.com/s/files/1/0924/7185/3320/files/badge-bpa-free-linen.svg?v=1787905391",
      "wotm":    "https://cdn.shopify.com/s/files/1/0924/7185/3320/files/badge-word-of-the-month-linen.svg?v=1787905391"
    }
  };
  function intTagActive(tags, base){
    for (var i=0;i<tags.length;i++){ var t=tags[i];
      if (t===base) return true;
      if (t.indexOf(base+":until:")===0){
        var raw=t.slice((base+":until:").length).trim();
        var hasTime=raw.indexOf(":")!==-1;
        var ms=Date.parse(raw.replace(" ","T"));
        if (isNaN(ms)) continue;
        if (!hasTime) ms+=86399000;
        if (ms>Date.now()) return true;
      }
    }
    return false;
  }
  function intBadgeImg(u,a){ return '<img src="'+u+'" alt="'+a+'" width="64" height="64" loading="lazy" decoding="async">'; }
  function siHeroColour(item){
    var vs=item&&item.shopify_variants; if(!Array.isArray(vs)||!vs.length) return "";
    var v0=vs[0]; if(!v0||!v0.options) return "";
    for (var k in v0.options){ var kl=k.toLowerCase(); if(kl.indexOf("color")!==-1||kl.indexOf("colour")!==-1||kl.indexOf("farve")!==-1) return String(v0.options[k]||""); }
    return "";
  }
  function intNewColourSpans(tags, shownColour){
    var out="", sc=(shownColour==null?"":String(shownColour)).trim().toLowerCase();
    for (var i=0;i<tags.length;i++){
      var t=tags[i];
      if (t.indexOf("badge:new-colour:")!==0) continue;
      var rest=t.slice("badge:new-colour:".length);
      var nc=rest.split(":until:")[0].trim();
      var ok=true;
      if (rest.indexOf(":until:")!==-1){
        var raw=rest.split(":until:")[1].trim();
        var hasTime=raw.indexOf(":")!==-1;
        var ms=Date.parse(raw.replace(" ","T"));
        if (!isNaN(ms)){ if(!hasTime) ms+=86399000; if (ms<=Date.now()) ok=false; }
      }
      if (!ok) continue;
      var ncl=nc.toLowerCase();
      out+='<span class="int-badge int-badge--newcolour'+(ncl===sc?" is-visible":"")+'" data-newcolour="'+ncl+'"><img src="'+SI.badgeNewColourSrc+'" alt="'+SI.t["int_pdp.badge_new_colour"]+'" width="64" height="64" loading="lazy" decoding="async"></span>';
    }
    return out;
  }
  function intBadges(item, shownColour){
    var tags=(item&&item.tags?String(item.tags):"").split("[:ATTR:]");
    var topNew="";
    if (intTagActive(tags,"badge:new-style")){ topNew='<span class="int-badge">'+intBadgeImg(INT_BADGE.urls.style,"New style")+'</span>'; }
    else { var pub=parseInt(item.published||item.created||"0",10); if (pub&&((Date.now()/1000-pub)<=INT_BADGE.days*86400)&&tags.indexOf("badge:no-new")===-1) topNew='<span class="int-badge">'+intBadgeImg(INT_BADGE.urls["new"],"New")+'</span>'; }
    var topLim=intTagActive(tags,"badge:limited-edition")?'<span class="int-badge">'+intBadgeImg(INT_BADGE.urls.limited,"Limited edition")+'</span>':"";
      var topBpa=intTagActive(tags,"badge:bpa-free")?'<span class="int-badge">'+intBadgeImg(INT_BADGE.urls.bpa,"BPA free")+'</span>':"";
    var topNC=intNewColourSpans(tags, shownColour);
    var topInner=topNew+topLim+topBpa+topNC;
    var top=topInner?'<div class="int-badges int-badges--top">'+topInner+'</div>':"";
    var wotm="";
    if (INT_BADGE.wotm && tags.indexOf("Intention:"+INT_BADGE.wotm)!==-1) wotm='<div class="int-badges int-badges--bottom"><span class="int-badge">'+intBadgeImg(INT_BADGE.urls.wotm,"Word of the month")+'</span></div>';
    return top+wotm;
  }
  function renderProducts(items, query, totalItems) {
    if (!Array.isArray(items) || !items.length) return '';
    var html = '';

    html += '<div class="si-section-title">Products</div>';
    html += '<div class="si-product-grid">';

    items.forEach(function(item) {
      var title = item.title || '';
      var link = item.link || '#';
link = link.replace(/\/collections\/[^\/]+\/products\//, '/products/');
      var img = pickMainImage(item);
      var img2 = pickFlipImage(item);

      /* INT 2026-07: `link` is the bare product URL, so the dropdown opened the
         PDP on the first variant - the smallest size. The tile shows the product's
         main image, which belongs to exactly one variant (the 60x80 hero), so
         match on that and link to it. Same rule as the search results page. */
      try{
        var _sv=item.shopify_variants||[];
        var _im=String(img||"").split("?")[0].split("/").pop();
        var _hit=_im&&_sv.find(function(v){
          return String(v.image_link||"").split("?")[0].split("/").pop()===_im;
        });
        if(_hit&&_hit.variant_id){link=link.split("?")[0]+"?variant="+_hit.variant_id;}
      }catch(e){}

      var subtitle = pickSubtitle(item);
      var labels = getLabels(item);
      var hasMulti = Array.isArray(item.shopify_variants) && item.shopify_variants.length > 1;
      var lowest = pickLowestPrice(item);
      var price = pickPrice(item);
      var displayPrice = hasMulti && lowest !== null ? money(lowest) : money(price);
      var prefix = '';

      var isFramed = subtitle && subtitle.toLowerCase().indexOf('frame') !== -1;
html += '<a class="si-product-card' + (isFramed ? ' si-product-framed' : '') + '" href="' + escapeHtml(link) + '">';
      html += '<div class="si-product-img-wrap">';
      html += intBadges(item, siHeroColour(item));

      /* Labels */
      if (labels.length) {
        html += '<div class="si-labels">';
        labels.forEach(function(lb) {
          html += '<span class="si-label ' + lb.cls + '">' + escapeHtml(lb.text) + '</span>';
        });
        html += '</div>';
      }

      if (img) {
        html += '<img class="si-product-img' + (img2 ? ' si-has-hover' : '') + '" loading="lazy" src="' + escapeHtml(img) + '" alt="' + escapeHtml(title) + '">';
      }
      if (img2) {
        html += '<img class="si-product-img-hover" loading="lazy" src="' + escapeHtml(img2) + '" alt="' + escapeHtml(title) + '">';
      }
      html += '</div>';

      html += '<div class="si-product-title">' + highlight(title, query) + '</div>';
      if (subtitle) {
        html += '<div class="si-product-subtitle">' + escapeHtml(subtitle) + '</div>';
      }
      html += '<div class="si-product-price">' + prefix + escapeHtml(displayPrice) + '</div>';
      html += '</a>';
    });

    html += '</div>';

    /* View All button */
    if (items.length > 0) {
      var total = Number(totalItems || items.length);
      var viewAllHref = API_PAGE + '?q=' + encodeURIComponent(query);
      html += '<div class="si-view-all-wrap">';
      html += '<a class="si-view-all-btn" href="' + escapeHtml(viewAllHref) + '">';
      html += ''+SI.t["int_hc.s0285"]+' ' + total + ' '+SI.t["int_hc.s0286"]+'';
      html += '</a></div>';
    }

    return html;
  }

  /* ── Main search handler ── */
  function doSearch(query) {
    if (!query || query.length < 1) {
      body.classList.remove('si-has-results');
      loader.classList.remove('si-loading');
      panel.classList.remove('si-has-content');
      leftCol.innerHTML = '';
      rightCol.innerHTML = '';
      return;
    }

    lastQuery = query;
    loader.classList.add('si-loading');
    body.classList.remove('si-has-results');
    panel.classList.add('si-has-content');

    fetchResults(query).then(function(data) {
      loader.classList.remove('si-loading');

      var suggestions = data.suggestions || [];
      var categories = data.categories || data.collections || [];
      var pages = data.pages || [];
      var items = data.items || [];
      var _siCurIndexed = items.some(function(it){ var vs = it && it.shopify_variants; if (!Array.isArray(vs)) return false; return vs.some(function(v){ return Object.keys(v).some(function(k){ return k.startsWith('price_') && k.endsWith('_' + SI_MARKET_CUR); }); }); });
      if (_siCurIndexed) items = items.filter(siOfferedInMarket);
      var _siRawCount = items.length;
      items = items.filter(function(it){ return !__intProductHidden(it); });
      var totalItems = data.totalItems || items.length;
      /* The API total counts the rows we just dropped, so never quote it once
         market suppression has removed anything - "VIEW ALL 112 PRODUCTS" for a
         US visitor meant 112 pages that all 404. */
      var _siSuppressed = items.length !== _siRawCount;
      if (_siSuppressed) totalItems = items.length;

      var hasAnything = suggestions.length || categories.length || pages.length || items.length;

      if (!hasAnything) {
        leftCol.innerHTML = '';
        /* Suppression, not a bad query: say which region this is, and where to go
           instead. Falls back to the ordinary empty state if no wording is set. */
        rightCol.innerHTML = (_siSuppressed && __intMarketNote()) || '<div class="si-empty">'+SI.t["int_hc.s0287"]+' "' + escapeHtml(query) + '"</div>';
        body.classList.add('si-has-results');
        return;
      }

      var leftHtml = '';
      leftHtml += renderSuggestions(suggestions, query);
      leftHtml += renderCategories(categories, query);
      leftHtml += renderPages(pages, query);
      leftCol.innerHTML = leftHtml;

      if (!leftHtml) {
        leftCol.style.display = 'none';
      } else {
        leftCol.style.display = '';
      }

      rightCol.innerHTML = items.length
        ? renderProducts(items, query, totalItems)
        : (_siSuppressed ? __intMarketNote() : '');
      body.classList.add('si-has-results');

    }).catch(function(err) {
      loader.classList.remove('si-loading');
      rightCol.innerHTML = '<div class="si-empty">'+SI.t["int_hc.s0273"]+'</div>';
      body.classList.add('si-has-results');
    });
  }

  /* ── Debounced input handler ── */
  input.addEventListener('input', function() {
    var q = input.value.trim();
    clearTimeout(debounceTimer);
    if (!q) {
      doSearch('');
      return;
    }
    debounceTimer = setTimeout(function() {
      doSearch(q);
    }, DEBOUNCE_MS);
  });

  /* ── Enter key → navigate to API page ── */
  input.addEventListener('keydown', function(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      var q = input.value.trim();
      if (q) {
        closeSearch();
        window.location.href = API_PAGE + '?q=' + encodeURIComponent(q);
      }
    }
    if (e.key === 'Escape') {
      closeSearch();
    }
  });

  /* ── Close handlers ── */
  closeBtn.addEventListener('click', closeSearch);
  backdrop.addEventListener('click', closeSearch);

  /* ── Hook into Pipeline's header search ── */
  function hookSearchTrigger() {
    var selectors = [
      '[data-popdown-toggle="search-popdown"]',
      '.site-header__search-btn',
      '.header__icon--search',
      '[href="#search"]',
      'button[aria-label="Search"]',
      '.search-icon',
      'a[href="/search"]',
      '.js-search-popdown-toggle'
    ];

    var triggers = [];
    selectors.forEach(function(sel) {
      var els = document.querySelectorAll(sel);
      els.forEach(function(el) { triggers.push(el); });
    });

    /* Deduplicate */
    var seen = new Set();
    triggers = triggers.filter(function(el) {
      if (seen.has(el)) return false;
      seen.add(el);
      return true;
    });

    triggers.forEach(function(trigger) {
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        openSearch();
      }, true);
    });

    if (!triggers.length) {
      /* Fallback: any header element with search-related attributes */
      var header = document.querySelector('#shopify-section-header, header, .site-header');
      if (header) {
        var links = header.querySelectorAll('a, button');
        links.forEach(function(el) {
          var text = (el.textContent || '').toLowerCase();
          var ariaLabel = (el.getAttribute('aria-label') || '').toLowerCase();
          var href = (el.getAttribute('href') || '').toLowerCase();
          if (text.includes('search') || ariaLabel.includes('search') || href.includes('search')) {
            el.addEventListener('click', function(e) {
              e.preventDefault();
              e.stopPropagation();
              openSearch();
            }, true);
          }
        });
      }
    }
  }

  /* ── Hook mobile hamburger menu search ── */
  function hookMobileSearch() {
    /* Pipeline's mobile drawer search input */
    var mobileSelectors = [
      '.drawer__search input[type="search"]',
      '.drawer__search input[type="text"]',
      '.mobile-nav input[type="search"]',
      '.mobile-nav input[type="text"]',
      '#MobileSearchInput',
      '.drawer input[name="q"]',
      '[data-search-popdown-input]'
    ];

    mobileSelectors.forEach(function(sel) {
      var els = document.querySelectorAll(sel);
      els.forEach(function(el) {
        if (el.dataset.siHooked) return;
        el.dataset.siHooked = 'true';

        /* When user focuses the mobile search input, open our panel instead */
        el.addEventListener('focus', function(e) {
          e.preventDefault();
          el.blur();
          openSearch();
        }, true);

        /* Also intercept typing */
        el.addEventListener('input', function(e) {
          e.preventDefault();
          e.stopPropagation();
          var q = el.value;
          el.value = '';
          openSearch();
          if (q) {
            setTimeout(function(){
              input.value = q;
              doSearch(q);
            }, 150);
          }
        }, true);
      });
    });

    /* Also hook any search submit buttons inside drawers */
    var drawerForms = document.querySelectorAll('.drawer form[action*="/search"], .mobile-nav form[action*="/search"]');
    drawerForms.forEach(function(form) {
      if (form.dataset.siHooked) return;
      form.dataset.siHooked = 'true';
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var qInput = form.querySelector('input[name="q"]');
        var q = qInput ? qInput.value.trim() : '';
        openSearch();
        if (q) {
          setTimeout(function(){
            input.value = q;
            doSearch(q);
          }, 150);
        }
      }, true);
    });
  }

  /* Run hooks after DOM is ready */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      hookSearchTrigger();
      hookMobileSearch();
    });
  } else {
    hookSearchTrigger();
    hookMobileSearch();
  }

  /* Re-hook after Pipeline's lazy header init */
  window.addEventListener('load', function() {
    setTimeout(function() {
      hookSearchTrigger();
      hookMobileSearch();
    }, 500);
  });

  /* Also observe DOM for dynamically injected drawers */
  if ('MutationObserver' in window) {
    var hookTimer = null;
    var obs = new MutationObserver(function() {
      clearTimeout(hookTimer);
      hookTimer = setTimeout(hookMobileSearch, 300);
    });
    obs.observe(document.body, { childList: true, subtree: true });
    /* Stop observing after 10s to avoid performance drag */
    setTimeout(function(){ obs.disconnect(); }, 10000);
  }

  /* ── Mobile page search bar on Searchanise pages ── */
  function injectMobilePageSearch() {
    /* Only on mobile */
    if (window.innerWidth > 820) return;

    /* Detect Searchanise pages */
    var isSearchPage = window.location.pathname.indexOf('/pages/page-searchanise-api') !== -1;
    var isCollectionPage = window.location.pathname.indexOf('/collections/') !== -1;
    var isProductPage = window.location.pathname.indexOf('/products/') !== -1;

    /* Only show on collection browsing and search results — NOT product pages */
    if (isProductPage) return;
    if (!isSearchPage && !isCollectionPage) return;

    /* Don't inject twice */
    if (document.getElementById('si_page_search')) return;

    /* Build the icon button */
    var bar = document.createElement('div');
    bar.className = 'si-page-search si-page-search-visible';
    bar.id = 'si_page_search';

    /* Detect if page has no banner image (Shop/all-collections page) */
    var hasBanner = document.querySelector('.collection__image, .collection-image, .hero, .hero__image, [class*="banner"], [class*="hero"]');
    if (!hasBanner) {
      bar.classList.add('si-page-search-no-banner');
    }

    bar.innerHTML = '<button class="si-page-search-btn" type="button" aria-label="Search">'
      + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">'
      + '<circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>'
      + '</svg>'
      + '</button>';

    bar.addEventListener('click', function(e) {
      e.preventDefault();
      openSearch();
    });

    /* Find the best insertion point — use actual navigation DOM classes */
    var inserted = false;

    /* Strategy 1: Insert before .sa-summary-bar (the "Showing X results" + sort row) */
    var summaryBar = document.querySelector('.sa-summary-bar');
    if (summaryBar && summaryBar.parentNode) {
      summaryBar.parentNode.insertBefore(bar, summaryBar);
      inserted = true;
    }

    /* Strategy 2: Insert before .sa-main */
    if (!inserted) {
      var saMain = document.querySelector('.sa-main');
      if (saMain && saMain.parentNode) {
        saMain.parentNode.insertBefore(bar, saMain);
        inserted = true;
      }
    }

    /* Strategy 3: Find "Showing X results" text by content */
    if (!inserted) {
      var allEls = document.querySelectorAll('p, div, span, h2, h3, h4');
      for (var i = 0; i < allEls.length; i++) {
        var txt = (allEls[i].textContent || '').trim();
        if (/showing\s+\d+\s+results?/i.test(txt) && allEls[i].offsetHeight > 0) {
          allEls[i].parentNode.insertBefore(bar, allEls[i]);
          inserted = true;
          break;
        }
      }
    }

    /* Last fallback: prepend to main content area */
    if (!inserted) {
      var main = document.querySelector('main, #MainContent, .main-content');
      if (main) {
        main.insertBefore(bar, main.firstChild);
      }
    }
  }

  /* ── Hide burger menu search on mobile ── */
  function hideBurgerSearch() {
    var style = document.createElement('style');
    style.textContent = ''
      + '@media (max-width: 820px) {'
      + '  .drawer__search, .mobile-nav__search,'
      + '  .drawer form[action*="/search"],'
      + '  .mobile-nav form[action*="/search"] {'
      + '    display: none !important;'
      + '  }'
      + '}';
    document.head.appendChild(style);
  }

  /* Run mobile bar injection */
  function initMobileBars() {
    hideBurgerSearch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileBars);
  } else {
    initMobileBars();
  }
})();
